export class LebeledInput {

	/**
	 * 
	 * @param {*} label HTML for Label
	 * @param {*} input HTML for Input
	 * @param {*} inputBefore If true Input is preceeding label for checkboxes
	 * @param {*} id If given the ID
	 * @param {*} classes A list of Strings
	 * @param {*} attributes An Object
	 * @returns 
	 */
	static create(label, input, inputBefore, id, classes, attributes) {
		let classesBuff = ''
		if (classes && classes.length) {
			classesBuff += ` ${classes.join(' ')}`
		}
		let attBuff = ''
		if (id) {
			attBuff += ` id="${id}"`
		}
		if (attributes) {
			attBuff += ' ' + Object.entries(attributes).map(([k, v]) => k + (v ? `="${v}"` : '')).join(' ')
		}
		return inputBefore 
			? `<div class="labeled-input input-before${classesBuff}"${attBuff}>
				<span class="radioWrapper">
					${input}
				</span>
				${label}
			</div>`
			: `<div class="labeled-input${classesBuff}"${attBuff}>
				${label}
				${input}
			</div>`
	}

}